/* eslint-env browser */
import scroll from './smoothScroll';

const getFormattedSelector = (selector) => {
  return selector[0] === '#' ? `[id='${selector.slice(1)}']` : selector;
};

export async function scrollToElement(
  selector,
  duration,
  offsetSelector,
  scrollToBottom,
  offsetHeightDiff = 0,
) {
  if (typeof window === 'undefined') {
    return;
  }

  const element = selector.nodeName
    ? selector
    : document.querySelector(getFormattedSelector(selector));
  if (!element) {
    return;
  }
  const offsetNode = document.querySelector(offsetSelector);
  const offsetHeight = offsetSelector && offsetNode ? offsetNode.clientHeight : 0;
  const rect = element.getBoundingClientRect();
  const {
    body: { scrollTop: bodyScrollTop, clientTop: bodyClientTop, clientHeight },
    documentElement: {
      scrollTop: docScrollTop,
      clientTop: docClientTop,
      clientHeight: docClientHeight,
    },
  } = document;
  const scrollTop = window.pageYOffset || docScrollTop || bodyScrollTop;
  const clientTop = docClientTop || bodyClientTop || 0;
  let top = rect.top + scrollTop - clientTop - offsetHeight - offsetHeightDiff;
  if (scrollToBottom) {
    const vHeight = docClientHeight || clientHeight || window.innerHeight;
    top -= vHeight - rect.height - 10;
  }
  return scroll({ y: Math.round(top) }, duration);
}

export function scrollToRef(el: HTMLElement, offsetY?: string | number = 0, target?: HTMLElement) {
  const targetTop = target?.offsetTop || 0;

  return el.scrollTo?.({
    left: 0,
    top: targetTop + offsetY,
  });
}
